import { render, staticRenderFns } from "./ChallengeDashboard.vue?vue&type=template&id=71186d03"
import script from "./ChallengeDashboard.vue?vue&type=script&lang=js"
export * from "./ChallengeDashboard.vue?vue&type=script&lang=js"
import style0 from "./ChallengeDashboard.vue?vue&type=style&index=0&id=71186d03&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports